module.exports = __webpack_public_path__ + "img/gemini.c424ced3.svg";